import $ from 'jquery'

let $blocks

export function init() {
  $(window).on('resize', () => recalculateTextBlocks())
  $(() => recalculateTextBlocks())
  recalculateTextBlocks()
}

export function recalculateTextBlocks() {
  $blocks = $('[class*="block-background-"]')
  $blocks.each((i, elem) => {
    let lastY = 0
    let initialX = 0
    $(elem)
      .find('.block-text')
      .each((i, word) => {
        word.classList.remove('first-in-line')
        const { top: y, left: x } = $(word).offset()
        if (i !== 0 && y > lastY && initialX === 0) initialX = x
        if (i === 0 || y > lastY || x === initialX) {
          word.classList.add('first-in-line')
          lastY = y
        }
      })
  })
}
